export function DataToShare() {
  return (
    <p>
      We rely on third-party service providers to perform a variety of services on our behalf. For example, we may rely on service providers to host data, process payment transactions and analyse data to improve our services. To do so, we may need to share your personal information with them:
      <br />
      <ul>
        <li>
          CloudFlare
          {' '}
          <a href="https://www.cloudflare.com/privacypolicy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          WordPress
          {' '}
          <a href="https://wordpress.org/about/privacy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          Zoho Products
          {' '}
          <a href="https://www.zoho.com/privacy.html" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          Amazon AWS
          {' '}
          <a href="https://aws.amazon.com/privacy/?nc1=f_pr" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          Sendgrid
          {' '}
          <a href="https://sendgrid.com/policies/privacy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          PORT
          {' '}
          <a href="https://www.port.im/privacy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          Google Apps for Business
          {' '}
          <a href="https://www.google.com/intl/en/policies/privacy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          Matomo
          {' '}
          <a href="https://matomo.org/privacy" target="_blank">
            Privacy Policy;
          </a>
        </li>
        <li>
          DigitalOcean
          {' '}
          <a href="https://www.digitalocean.com/legal/privacy" target="_blank">
            Privacy Policy.
          </a>
        </li>
      </ul>
      It may be necessary to transfer your data to suppliers/service providers where we rely on storage, system and administrative support from outside the European Economic Area.  Therefore, the processing of your data may involve a transfer of data to countries outside of European Union.
    </p>
  );
}

export default DataToShare;
